export default "__VITE_ASSET__Cc2t7wID__"